var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { createSelector } from 'reselect';
import { initialState } from './reducer';
/**
 * Direct selector to the organization developer plan state domain
 */
export var selectOrganizationDevPlanDomain = function (state) {
    return state.orgDevPlans || initialState;
};
var selectDeveloperPlans = function (state) {
    return ((state === null || state === void 0 ? void 0 : state.orgDevPlans) || initialState).developerPlans;
};
export var selectDeveloperPlansOrg = function (state) {
    return ((state === null || state === void 0 ? void 0 : state.orgDevPlans) || initialState).developerPlansOrg;
};
export var selectDeveloperPlanConsume = function (state) {
    return ((state === null || state === void 0 ? void 0 : state.orgDevPlans) || initialState).devPlanConsume;
};
export var selectDeveloperPlanConsumeOrg = function (state) {
    return ((state === null || state === void 0 ? void 0 : state.orgDevPlans) || initialState).devPlanConsumeOrg;
};
export var selectDevPlanInvoiceDetails = function (state) {
    return ((state === null || state === void 0 ? void 0 : state.orgDevPlans) || initialState).devPlanInvoiceDetails;
};
export var selectDevPlanInvoiceDetailsOrg = function (state) {
    return ((state === null || state === void 0 ? void 0 : state.orgDevPlans) || initialState).devPlanInvoiceDetailsOrg;
};
export var selectDevPlanBundlesOrg = function (state) {
    return ((state === null || state === void 0 ? void 0 : state.orgDevPlans) || initialState).bundlesOrg;
};
export var selectActiveBundlesOrg = function (state) {
    return ((state === null || state === void 0 ? void 0 : state.orgDevPlans) || initialState).activeBundlesOrg;
};
export var selectActiveBundles = function (state) {
    return ((state === null || state === void 0 ? void 0 : state.orgDevPlans) || initialState).activeBundles;
};
export var selectDeveloperPlanStatusLoading = function (state) {
    return ((state === null || state === void 0 ? void 0 : state.orgDevPlans) || initialState).devPlanStatus_loading;
};
export var selectUpdatedAddons = function (state) {
    return ((state === null || state === void 0 ? void 0 : state.orgDevPlans) || initialState).updatedAddons;
};
export var selectProRatedAmount = function (state) {
    return ((state === null || state === void 0 ? void 0 : state.orgDevPlans) || initialState).proRatedAmount;
};
export var selectProRatedAmountLoading = function (state) {
    return ((state === null || state === void 0 ? void 0 : state.orgDevPlans) || initialState).proRatedAmount_loading;
};
export var selectProRatedAmountError = function (state) {
    return ((state === null || state === void 0 ? void 0 : state.orgDevPlans) || initialState).proRatedAmount_error;
};
export var selectDevPlanConsumeLoading = function (state) {
    return ((state === null || state === void 0 ? void 0 : state.orgDevPlans) || initialState).devPlanConsume_loading;
};
export var selectDevPlanConsumablesCount = function (state) {
    return ((state === null || state === void 0 ? void 0 : state.orgDevPlans) || initialState).devPlanConsumablesCount;
};
export var selectPurchaseDevPlanBundleLoading = function (state) {
    return ((state === null || state === void 0 ? void 0 : state.orgDevPlans) || initialState).purchase_dev_plan_bundle_loading;
};
export var selectPurchaseDevPlanBundleError = function (state) {
    return ((state === null || state === void 0 ? void 0 : state.orgDevPlans) || initialState).purchase_dev_plan_bundle_error;
};
export var selectResellerDetailsForManagedOrg = function (state) {
    return ((state === null || state === void 0 ? void 0 : state.orgDevPlans) || initialState).resellerDetails;
};
export var selectResellerDetailsForManagedOrgId = function (state) {
    return ((state === null || state === void 0 ? void 0 : state.orgDevPlans) || initialState).resellerDetailsOrg;
};
export var selectProratedAmountForAddons = function (state) {
    return ((state === null || state === void 0 ? void 0 : state.orgDevPlans) || initialState).proratedAmountForAddons;
};
export var makeSelectDevPlanConsumeLoading = function () {
    return createSelector(selectDevPlanConsumeLoading, function (devPlanConsumeLoading) { return devPlanConsumeLoading; });
};
export var makeSelectActiveDeveloperPlan = createSelector(selectDeveloperPlans, function (devPlans) {
    return (devPlans === null || devPlans === void 0 ? void 0 : devPlans.find(function (plan) { return plan.active_dev_plan; })) || {};
});
export var makeSelectDeveloperPlanConsume = function () {
    return createSelector(selectDeveloperPlanConsume, function (devPlanConsume) { return devPlanConsume; });
};
export var makeSelectActiveBundles = createSelector(selectActiveBundles, function (activeBundles) { return activeBundles; });
export var selectFilterdDevPlans = createSelector(selectOrganizationDevPlanDomain, function (plans) {
    var plan = plans.developerPlans.filter(function (e) { return e.interval === plans.interval; });
    var orderedDevPlans = __spreadArray(__spreadArray([], plan.filter(function (e) { return e.active_dev_plan; }), true), plan.filter(function (e) { return !e.active_dev_plan; }), true);
    return orderedDevPlans;
});
export var makeSelectDevPlans = createSelector(selectOrganizationDevPlanDomain, function (substate) {
    return substate;
});
